import { AccountBalance } from './../PaymentMethod'
import { Frequency, mapFrequency } from './../Frequency'
import * as api from '../task-detail-api'
import { TransactionType } from '../TransactionType'
import { Policy } from '../Client'
import { SourceType } from '../SourceType'
import moment from 'moment'
import { BillingChange as BillingChangeType } from '../BillingChange'
import { pipe } from 'fp-ts/lib/function'
import * as O from 'fp-ts/lib/Option'
import { EFormBillingChange } from '../EFormBillingChange'
export interface BillingChange {
  tag: TransactionType.BILLING_CHANGE | TransactionType.BILLING_CHANGE_CORPORATE
  source: SourceType
  clientName: string
  currentFrequency: string
  currentRenewalPremium: number | null
  paidToDate: string | null
  newFrequency: string
  newRenewalPremium: number | null
  suspendAmount: number | null
  effectiveDate: string | null
  advancePremium: number | null
  billToDate: string | null
  requirePayinAmount: number | null
  receiptILP: number | null
}

export const BillingChange = (
  detail: api.BillingChange,
  policy: Policy | null,
  billingChangeData: EFormBillingChange,
  poName: string,
  accountBalanceLP_U: Array<AccountBalance>,
  nextInstallmentPremiumData: BillingChangeType.NextInstallmentPre
): BillingChange => {
  const _advancePremium = Number(billingChangeData.body.premiumAdv || '0')
  const contractDay = policy && policy.body.contractDate?.split('-')[2] ? policy.body.contractDate?.split('-')[2] : ''
  const contractMonth = policy && policy.body.contractDate?.split('-')[1] ? policy.body.contractDate?.split('-')[1] : ''
  const effectiveDateNewFrequency = `${contractDay}/${contractMonth}/${new Date().getFullYear()}`
  const clientName = poName
  const currentFrequency = billingChangeData.body.curBillingFrequency ?? '' // from core
  const receiptILP = pipe(
    O.fromNullable(accountBalanceLP_U),
    O.fold(
      () => 0,
      (balances) => balances.reduce((total, e) => {
        return total + (e.sacsCode === 'LP' && e.sacsType === 'U' ? e.amount : 0)
      }, 0)
    )
  )
  switch (detail.source) {
    case SourceType.BANCA:
    case SourceType.PRUGREAT: {
      const _data = detail.payload
      const _currentRenewalPremium = _data && _data.body.curRenewalPremium ? Number(_data.body.curRenewalPremium) : 0
      // const newInstallmentPremium = 0
      const nextInstallmentPremiumFromCore = nextInstallmentPremiumData?.nextInstallmentPremium ? Number(nextInstallmentPremiumData.nextInstallmentPremium) : 0
      return {
        tag: detail.transactionType,
        source: detail.source,
        clientName: clientName,
        currentFrequency,
        currentRenewalPremium: _currentRenewalPremium,
        paidToDate: _data.body.paidToDate || '-',
        newFrequency: _data.body.newBillingFrequency
          ? Number(_data.body.newBillingFrequency)
            ? mapFrequency.get(_data.body.newBillingFrequency as Frequency) ?? ''
            : _data.body.newBillingFrequency
          : '-',
        newRenewalPremium: nextInstallmentPremiumFromCore,
        suspendAmount: Number(billingChangeData.body.suspendAmount) ?? 0,
        effectiveDate: effectiveDateNewFrequency ? effectiveDateNewFrequency : null,
        advancePremium: _advancePremium,
        billToDate: _data.body.billToDate || '-',
        requirePayinAmount:
          nextInstallmentPremiumFromCore -
          (Number(billingChangeData.body.suspendAmount) ?? 0 + _advancePremium + receiptILP),
        receiptILP
      }
    }
    case SourceType.EKIOSK: {
      const data = detail.payload.body
      const nextInstallmentPremiumFromCore = nextInstallmentPremiumData?.nextInstallmentPremium ? Number(nextInstallmentPremiumData.nextInstallmentPremium) : 0
      return {
        tag: detail.transactionType,
        source: detail.source,
        clientName: clientName,
        currentFrequency,
        currentRenewalPremium: Number(billingChangeData.body.curRenewalPremium || 0),
        paidToDate: '-',
        newFrequency: data.newBillingFrequency ?? '-',
        newRenewalPremium: nextInstallmentPremiumFromCore,
        suspendAmount: Number(billingChangeData.body.suspendAmount) ?? 0,
        effectiveDate: effectiveDateNewFrequency ? effectiveDateNewFrequency : null,
        advancePremium: _advancePremium,
        billToDate: null,
        requirePayinAmount:
          nextInstallmentPremiumFromCore -
          ((Number(billingChangeData.body.suspendAmount) || 0) + (_advancePremium || 0) + receiptILP),
        receiptILP
      }
    }
    case SourceType.ZALO:
    case SourceType.PULSE4OPS:
    case SourceType.PULSE:
    case SourceType.PRUSERVICES:
    case SourceType.PRUONLINE: {
      const body = detail.payload.body
      // const newRenewalPremium4ops = body.newInstallmentPremium ? Number(body.newInstallmentPremium) : 0
      const nextInstallmentPremiumFromCore = nextInstallmentPremiumData?.nextInstallmentPremium ? Number(nextInstallmentPremiumData.nextInstallmentPremium) : 0
      const suspendAmount4ops = Number(billingChangeData.body.suspendAmount) ?? 0
      const detectFormatDDMMYYYY = (date: string = '') =>
        moment(body?.effectiveDateNewFrequency, 'DD/MM/YYYY', true).isValid()
          ? date
          : moment(date ?? '', 'YYYYMMDD').format('DD/MM/YYYY')

      let effectiveDate: string | null = ''
      if (detail.source === SourceType.PULSE4OPS) {
        effectiveDate = body?.effectiveDateNewFrequency ? body?.effectiveDateNewFrequency : null
      } else {
        effectiveDate = body?.effectiveDateNewFrequency ? detectFormatDDMMYYYY(body?.effectiveDateNewFrequency) : null
      }

      return {
        tag: detail.transactionType,
        source: detail.source,
        clientName: clientName,
        currentFrequency:
          [SourceType.PULSE, SourceType.PRUONLINE].includes(detail.source) || TransactionType.BILLING_CHANGE_CORPORATE
            ? detail.payload.body.curBillingFrequency || ''
            : currentFrequency,
        currentRenewalPremium: [SourceType.PULSE, SourceType.PRUONLINE].includes(detail.source)
          ? body?.curInstallmentPremium
            ? Number(body?.curInstallmentPremium)
            : 0
          : body?.curRenewalPremium
            ? Number(body.curRenewalPremium)
            : 0,
        paidToDate: body?.paidToDate ?? '',
        newFrequency: body?.newBillingFrequency ?? '-',
        newRenewalPremium: nextInstallmentPremiumFromCore,
        suspendAmount: suspendAmount4ops,
        effectiveDate: effectiveDate,
        advancePremium: _advancePremium,
        billToDate: body?.billToDate ? body.billToDate : '',
        requirePayinAmount: nextInstallmentPremiumFromCore - (suspendAmount4ops + _advancePremium + receiptILP),
        receiptILP
      }
    }
  }
}
